/* eslint-disable @typescript-eslint/no-explicit-any */
import { EnvironmentConfig } from './models';
import { globalTrackingService } from './services';

export const TrackingService = globalTrackingService;

export function setupConfig(config: EnvironmentConfig) {
    if (!window) {
        return;
    }

    const win = window as any;
    const csb = win.csb;

    if (csb && csb.config && csb.config.constructor.name !== 'Object') {
        console.warn('csbextensions config was already initialized');
        return;
    }
    win.csb = win.csb || {};
    win.csb.config = {
        ...win.csb.config,
        ...config,
    };
    win.csb.config.preferred = true;

    return win.csb.config;
}

export function setupStyles() {
    const win = window as any;
    if (!win) {
        return;
    }
    const doc = win.document;
    const fileref = doc.createElement('link');
    const config = getConfig();
    const baseUrl = config.hostingUrl;
    const version = config.version;

    fileref.setAttribute('rel', 'stylesheet');
    fileref.setAttribute('type', 'text/css');
    fileref.setAttribute('href', baseUrl + '/build/csb.css?v=' + version);
    fileref.onload = () => {
        win.dispatchEvent(new CustomEvent('loaded.csbstylesheet'));
    };
    setTimeout(() => {
        doc.head.insertBefore(fileref, doc.head.childNodes[doc.head.childNodes.length - 1].nextSibling);
    }, 100);
}

export function getConfigValue(key?: string): any {
    if (!window) {
        return undefined;
    }

    const win = window as any;
    const csb = win.csb;
    if (!key) {
        return csb.config;
    }
    return csb.config[key];
}

export function getConfig(): EnvironmentConfig {
    const win = window as any;
    const csb = win.csb;
    return csb.config;
}
